"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BaseSeoManagerEncoder = _interopRequireDefault(require("./BaseSeoManagerEncoder"));

var _homonymoustowns = _interopRequireDefault(require("../helpers/homonymoustowns.json"));

var _slugify = require("../helpers/slugify");

var _utils = require("../helpers/utils");

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _HelmetHelper = require("../meta/HelmetHelper");

var _MiddlewareRedirectHelper = require("../helpers/MiddlewareRedirectHelper");

var _helpers = require("../utils/helpers");

var _MetroStopsDisambiguation = _interopRequireDefault(require("../helpers/MetroStopsDisambiguation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SeoManagerEncoderV2 = /*#__PURE__*/function (_BaseSeoManagerEncode) {
  _inherits(SeoManagerEncoderV2, _BaseSeoManagerEncode);

  var _super = _createSuper(SeoManagerEncoderV2);

  function SeoManagerEncoderV2(_this) {
    var _this2;

    _classCallCheck(this, SeoManagerEncoderV2);

    _this2 = _super.call(this, _this);
    _this2.domain = _this.domain;
    _this2.lang = _this.lang;
    _this2.supported_lang_slug = _this.supported_lang_slug;
    _this2.data = _this.data;
    _this2.num_levels = _this.num_levels;
    _this2.immotype = _this.immotype;
    _this2.encode_parts = _this.encode_parts;
    _this2.encode_qs = _this.encode_qs;
    return _this2;
  }

  _createClass(SeoManagerEncoderV2, [{
    key: "getParentsFromLocality",
    value: function getParentsFromLocality(loc) {
      var parents = (loc === null || loc === void 0 ? void 0 : loc.parents) || (loc === null || loc === void 0 ? void 0 : loc.parent) || [];

      if (Array.isArray(parents)) {
        return parents;
      }

      return Object.keys(parents).map(function (p) {
        return parents[p].level ? {
          name: parents[p].name,
          slug: parents[p].slug,
          slugs: parents[p].slugs,
          hkey: parents[p].hkey,
          level: parents[p].level,
          type: p
        } : null;
      }).filter(Boolean);
    }
  }, {
    key: "isValidLocationForSeoUrl",
    value: function isValidLocationForSeoUrl(locations) {
      if (locations && locations.length === 1) {
        var loc = locations[0];
        var parents = this.getParentsFromLocality(loc);

        if (loc.level === 4 || loc.level === 6 || loc.level === 9 || (loc.level === 10 || loc.level === 118) && // zone e linee del metro
        parents.map(function (l) {
          return l.level === 9 ? true : null;
        }).filter(Boolean).length === 1 || loc.level === 11 && parents.map(function (l) {
          return l.level === 10 ? true : null;
        }).filter(Boolean).length === 1 || loc.level === 120 && // fermate del metro
        parents.map(function (l) {
          return l.level === 118 ? true : null;
        }).filter(Boolean).length === 1 || loc.level === 130 // zna
        || loc.level === 132 && // zna subzone
        parents.map(function (l) {
          return l.level === 130 ? true : null;
        }).filter(Boolean).length === 1 && !['postalcode', 'freetext'].includes(loc.type)) {
          return true;
        }
      } else if (locations && locations.length === 0) {
        return true;
      }

      return false;
    }
  }, {
    key: "isValidParamsForSeoUrl",
    value: function isValidParamsForSeoUrl(params, locations) {
      var has_transaction = false;
      var has_propertyTypes = false;
      var is_publisher_hp = false;
      var is_agent_pro = true;

      if (params.geobounds || params.geocircle || params.geopolygon || params.geopoint || params.isMap || params.nearby) {
        return false;
      }

      var has_locations = this.isValidLocationForSeoUrl(locations);

      if ('tr' in params && params.tr) {
        has_transaction = true;
      }

      if ('propertyTypes' in params && params.propertyTypes && !(0, _SeoManagerHelpers.isDictionary)(params.propertyTypes)) {
        if (!Array.isArray(params.propertyTypes)) {
          params.propertyTypes = params.propertyTypes.split(/,/);
        }

        if (params.propertyTypes && params.propertyTypes.length > 1) {
          return false;
        } else if (params.propertyTypes && params.propertyTypes.length === 1) {
          var ptype = (0, _SeoManagerHelpers.getChildrenImmotypeSlugFromKeys)(params.category, params.propertyTypes[0], this.lang, null, {
            forceSrpUrl: false
          });

          if (ptype) {
            has_propertyTypes = true;
          } else {
            has_propertyTypes = false;
          }
        }
      } else {
        has_propertyTypes = false;
      }

      if (params.license_type_groups) {
        if (!Array.isArray(params.license_type_groups)) {
          params.license_type_groups = params.license_type_groups.split(/,/);
        }

        if (params.license_type_groups.length > 1 || _SeoManagerHelpers.LICENSE_TYPES_TO_EXCLUDE_FROM_SEO_URL.includes(params.license_type_groups[0])) {
          return false;
        }
      }

      if ('isPublisherHp' in params && params.isPublisherHp && 'publisherId' in params) {
        is_publisher_hp = true;
      }

      if (params.isAgentProPage && 'publisherId' in params) {
        is_agent_pro = true;
      }

      if ((!has_locations || !has_transaction) && !is_publisher_hp && !is_agent_pro) {
        return false;
      }

      if (locations && locations.length > 1) {
        return false;
      }

      if (params.sellerType) {
        var sellerType = Array.isArray(params.sellerType) ? params.sellerType : params.sellerType.split(',');

        if (sellerType.length > 1) {
          return false;
        }
      }

      if (params.buildingCondition) {
        var buildingCondition = Array.isArray(params.buildingCondition) ? params.buildingCondition : params.buildingCondition.split(',');

        if (buildingCondition.length > 1) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "getDefaultLoc",
    value: function getDefaultLoc(loc) {
      var slug = loc.slug,
          slugs = loc.slugs,
          name = loc.name,
          key = loc.key,
          search_data = loc.search_data,
          level = loc.level;

      if (slug) {
        return slug;
      }

      if (slugs) {
        return slugs;
      }

      if (search_data && search_data.geo && search_data.geo.slug_levels) {
        var slug_levels = search_data.geo.slug_levels;
        var locSlug = slug_levels["L".concat(level)];

        if (locSlug) {
          return locSlug;
        }
      }

      return (name ? (0, _slugify.slugifyp)(name) : name) || (key ? key.split(',')[0] : '');
    }
  }, {
    key: "getLocationStr",
    value: function getLocationStr(locations) {
      if (locations.length === 0) {
        return '';
      }

      var item = locations[0];
      var default_loc = this.getDefaultLoc(item);

      var getProvinceShort = function getProvinceShort() {
        try {
          if (item && item.parent && item.parent.province && item.parent.province["short"]) {
            return item.parent.province["short"].toLowerCase();
          } else if (item && item.parent && item.parent.province && item.parent.province.id) {
            item.parent.province.id.split('-')[2].toLowerCase();
          }

          return null;
        } catch (error) {
          console.error("Encode V1: getLocationStr: getProvinceShort: error: ".concat(error));
          return null;
        }
      };

      var loc;

      switch (item.level) {
        case 4:
          loc = item.slug || default_loc;
          break;

        case 6:
          loc = "".concat(item.slug || default_loc, "-provincia");
          break;

        case 9:
          loc = item.slug || default_loc;

          if (_homonymoustowns["default"][loc]) {
            loc = "".concat(loc, "-").concat(getProvinceShort());
          }

          break;

        case 10:
          {
            var parents = this.getParentsFromLocality(item);
            var l9 = parents.map(function (l) {
              return l.level === 9 ? l : null;
            }).filter(Boolean)[0];
            var zone_prefix = '';
            var zone_type = item.type || '';

            switch (zone_type.toLowerCase()) {
              case 'frazione':
              case 'zone':
                break;

              case 'zone commerciali':
              case 'zci':
                zone_prefix = 'zci-';
                break;

              case 'zone omi':
              case 'omi':
                zone_prefix = 'omi-';
                break;

              case 'indirizzi':
              case 'street':
                zone_prefix = 'ind-';
                break;

              default:
                break;
            }

            var default_l9_loc = l9.slug || l9.slugs || (l9.name ? (0, _slugify.slugify)(l9.name) : l9.name) || (l9.key ? l9.key.split(',')[0] : '');

            if (_homonymoustowns["default"][default_l9_loc]) {
              default_l9_loc = "".concat(default_l9_loc, "-").concat(getProvinceShort());
            }

            loc = "".concat(default_l9_loc, "/").concat(zone_prefix).concat(item.slug || default_loc);
            break;
          }

        case 11:
          {
            var _parents = this.getParentsFromLocality(item);

            var _l = _parents.map(function (l) {
              return l.level === 9 ? l : null;
            }).filter(Boolean)[0];

            var l10 = _parents.map(function (l) {
              return l.level === 10 ? l : null;
            }).filter(Boolean)[0];

            var _default_l9_loc = _l.slug || _l.slugs || (_l.name ? (0, _slugify.slugify)(_l.name) : _l.name) || (_l.key ? _l.key.split(',')[0] : '');

            var default_l10_loc = l10.slug || l10.slugs || (l10.name ? (0, _slugify.slugify)(l10.name) : l10.name) || (l10.key ? l10.key.split(',')[0] : '');
            loc = "".concat(_default_l9_loc, "/").concat(default_l10_loc, "/").concat(item.slug || default_loc);
            break;
          }

        case 118:
          {
            var _parents2 = this.getParentsFromLocality(item);

            var _l2 = _parents2.map(function (l) {
              return l.level === 9 ? l : null;
            }).filter(Boolean)[0];

            var _default_l9_loc2 = _l2.slug || _l2.slugs || (_l2.name ? (0, _slugify.slugify)(_l2.name) : _l2.name) || (_l2.key ? _l2.key.split(',')[0] : '');

            if (_homonymoustowns["default"][_default_l9_loc2]) {
              _default_l9_loc2 = "".concat(_default_l9_loc2, "-").concat(getProvinceShort());
            }

            loc = "".concat(_default_l9_loc2, "/").concat(item.slug || default_loc);
            break;
          }

        case 120:
          {
            var _parents3 = this.getParentsFromLocality(item);

            var _l3 = _parents3.map(function (l) {
              return l.level === 9 ? l : null;
            }).filter(Boolean)[0];

            var l118 = _parents3.map(function (l) {
              return l.level === 118 ? l : null;
            }).filter(Boolean)[0];

            var _default_l9_loc3 = _l3.slug || _l3.slugs || (_l3.name ? (0, _slugify.slugify)(_l3.name) : _l3.name) || (_l3.key ? _l3.key.split(',')[0] : '');

            var default_l118_loc = l118.slug || l118.slugs || (l118.name ? (0, _slugify.slugify)(l118.name) : l118.name) || (l118.key ? l118.key.split(',')[0] : '');
            loc = "".concat(_default_l9_loc3, "/").concat(default_l118_loc, "/").concat(item.slug || default_loc);
            break;
          }

        case 130:
          {
            loc = item.slug || default_loc;
            break;
          }

        case 132:
          {
            var _parents4 = this.getParentsFromLocality(item);

            var l130 = _parents4.map(function (l) {
              return l.level === 130 ? l : null;
            }).filter(Boolean)[0];

            var default_l130_loc = l130.slug || l130.slugs || (l130.name ? (0, _slugify.slugify)(l130.name) : l130.name) || (l130.key ? l130.key.split(',')[0] : '');
            loc = "".concat(default_l130_loc, "/").concat(item.slug || default_loc);
            break;
          }

        default:
          loc = "area-".concat(item.level, "-").concat(item.slug || default_loc);
          break;
      }

      return loc.toLowerCase();
    }
  }, {
    key: "encodeSeoUrl",
    value: function encodeSeoUrl(paramsFrom, locations) {
      var params = JSON.parse(JSON.stringify(paramsFrom));
      params.propertyTypeGroup = params.propertyTypeGroup !== params.category && params.category ? params.category : params.propertyTypeGroup;
      delete params.category; // TECH-6445: EXCLUDE EVERY PROPERTY TYPE ITEM THAT EQUALS EMPTY STRING

      if (params.propertyTypes && Array.isArray(params.propertyTypes)) {
        var noEmptyPTValues = params.propertyTypes.filter(function (pt) {
          return pt && pt !== '';
        }); // if there are no valid ptypes remove the param

        if (noEmptyPTValues.length === 0) {
          delete params.propertyTypes; // if there is a new set of valid ptypes update the param
        } else if (params.propertyTypes.length !== noEmptyPTValues.length) {
          params.propertyTypes = noEmptyPTValues;
        }
      }
      /* INITIALIZE POI TO HAVE TO DIFFERENT OBJECT AND NOT MODIFY THE FIRST REFERENCE */


      var qs = _objectSpread({}, params, {}, params.poi && {
        poi: _objectSpread({}, params.poi)
      });

      if ('isPublisherHp' in params && params.isPublisherHp && 'publisherId' in params) {
        var publisherQs = JSON.parse(JSON.stringify(params));
        delete publisherQs.publisherId;
        delete publisherQs.publisherSlug;
        delete publisherQs.isPublisherHp;
        delete publisherQs.locations;
        delete publisherQs.propertyTypeGroup;
        var pqs = this.getQS(publisherQs);
        var name = 'publisherSlug' in params && params.publisherSlug ? "".concat(params.publisherSlug.toLowerCase().replace(/\/+/g, '').trim(), "-") : '';

        var _url = (0, _utils.normalizePublisherUrl)("/agenzie/".concat(name).concat(params.publisherId));

        return "".concat(_url).concat(pqs === '' ? '/' : pqs);
      }

      if (params.isAgentProPage && 'publisherId' in params) {
        var _qs = params.queryObject || {};

        var paramsAndQs = _objectSpread({}, _qs, {}, params);

        var _publisherQs = JSON.parse(JSON.stringify(paramsAndQs));

        delete _publisherQs.publisherId;
        delete _publisherQs.publisherSlug;
        delete _publisherQs.isAgentProPage;
        delete _publisherQs.locations;
        delete _publisherQs.propertyTypeGroup;

        var _pqs = this.getQS(_publisherQs);

        var _name = 'publisherSlug' in params && params.publisherSlug ? "".concat(params.publisherSlug.toLowerCase().replace(/\/+/g, '').trim(), "-") : '';

        var _url2 = (0, _utils.normalizePublisherUrl)("/agenzie/".concat(_name).concat(params.publisherId, "/agenti"));

        return "".concat(_url2).concat(_pqs === '' ? '/' : _pqs);
      }

      var validPtype = null;
      var has_locations = this.isValidLocationForSeoUrl(locations);

      if (has_locations && !params.tr && !params.propertyTypes && !params.agency) {
        var locationPath = "/".concat(this.getEncode()[this.lang]['real-estate'], "/").concat(this.getLocationStr(locations));
        delete qs.locations;

        var _gqs = this.getQS(qs);

        return "".concat(locationPath).concat(_gqs.length ? _gqs : '/');
      }

      var paramsPath = [];

      if (params.liste) {
        paramsPath.push(params.liste);
        delete qs.liste;
      } // pages for non-administrative zones: /geo/vendita/residenziale/lago-di-garda/


      var isZNAPage = !!params.nonAdminPrefix;

      if (isZNAPage) {
        paramsPath.push(params.nonAdminPrefix);
        delete qs.nonAdminPrefix;
      }

      if (params.agency) {
        if (!params.propertyTypeGroup) {
          delete qs.propertyTypeGroup;
        }

        paramsPath.push(params.agency);
        delete qs.agency;
      }

      if (params.tr) {
        paramsPath.push(this.getTREncode()[this.lang][params.tr]);
        delete qs.tr;
      }

      if (params.propertyTypeGroup && params.propertyTypes) {
        var ptype = (0, _SeoManagerHelpers.getChildrenImmotypeSlugFromKeys)(params.propertyTypeGroup, params.propertyTypes[0], this.lang, true, {
          forceSrpUrl: false
        });

        if (ptype) {
          if (this.isPTYPEEncodeToExclude(qs.propertyTypeGroup, ptype)) {
            if (qs.propertyTypeGroup === ptype) {
              params.propertyTypeGroup = params.propertyTypes[0];
              delete params.propertyTypes;
            }

            return this.encodeSrpUrl(params, locations);
          }

          if ((0, _SeoManagerHelpers.findImmotypes)(this.lang, ptype).length > 1 && (qs.propertyTypeGroup === 'vacanze' || qs.propertyTypeGroup === 'case-vacanza')) {
            ptype = "".concat(this.getCATEncode(qs.propertyTypeGroup), "-").concat(ptype);
          } // For non-administrative zones, if has ptypes and is a child of a non-administrative zone, return srp url
          // if(this.hasChildOfNonAdminZone(locations)){
          //   delete params.nonAdminPrefix;
          //   return this.encodeSrpUrl(params, locations);
          // }


          paramsPath.push(ptype);
          validPtype = ptype;
          delete qs.propertyTypes;
          delete qs.propertyTypeGroup;
        }
      } else if (params.propertyTypeGroup && !params.propertyTypes) {
        if (this.isPTYPEEncodeToExclude(qs.propertyTypeGroup, qs.propertyTypeGroup)) {
          params.propertyTypeGroup = qs.propertyTypeGroup;
          return this.encodeSrpUrl(params, locations);
        }

        paramsPath.push(this.getCATEncode(qs.propertyTypeGroup));
        delete qs.propertyTypeGroup;
      }

      if (params.buildingCondition) {
        var bc = Array.isArray(params.buildingCondition) ? params.buildingCondition[0] : params.buildingCondition;
        bc = _SeoManagerHelpers.BUILDING_CONDITION_ENCODE[this.lang][bc];

        if (bc && bc.slug) {
          if (bc.slug === 'in-nuove-costruzioni' && params.propertyTypeGroup === 'commerciale') {
            return this.encodeSrpUrl(params, locations);
          }

          paramsPath.push(bc.slug);
          delete qs.buildingCondition;
        }
      }
      /**
       * non-administrative zones urls dont have seo url with filters
       * only with license_type_groups
       */


      if (isZNAPage && Object.keys(qs).length > 0) {
        var hasFilters = Object.keys(qs).filter(function (key) {
          if (key === 'isMap') {
            return qs[key];
          } else if (key === 'nearby') {
            return qs[key];
          } else if (key === 'page') {
            return qs[key] !== 1;
          } else if (key !== 'locations' && key !== 'license_type_groups' && key !== 'sortType') {
            return true;
          }

          return false;
        });

        if (hasFilters.length > 0) {
          delete params.nonAdminPrefix;
          return this.encodeSrpUrl(params, locations);
        }
      } // se ha solo numRooms -> encoda srpurl


      if (params.numRooms && !params.numRoomsMax && !params.numRoomsMax) {
        return this.encodeSrpUrl(params, locations); // se ha numRoomsMin o numRoomsMax
      } else if (params.numRoomsMin || params.numRoomsMax) {
        // se ha propertyTypes -> encoda srpurl 
        if (params.propertyTypes && params.propertyTypes.length > 0) {
          return this.encodeSrpUrl(params, locations); // invece, se è residenziale e numRoomsMin è uguale a numRoomsMax
        } else if ((params.propertyTypeGroup === 'case' || params.propertyTypeGroup === 'residenziale') && params.numRoomsMax === params.numRoomsMin) {
          // se il valore di numRoomsMin è un valore seo -> encoda la seo url
          var cRooms = _SeoManagerHelpers.ROOMS_ENCODE[params.numRoomsMin];

          if (cRooms) {
            paramsPath.push(cRooms);
            delete qs.numRooms;
            delete qs.numRoomsMin;
            delete qs.numRoomsMax; // altrimenti -> encoda srpurl 
          } else {
            return this.encodeSrpUrl(params, locations);
          } // in tutti gli altri casi -> encoda srpurl 

        } else {
          return this.encodeSrpUrl(params, locations);
        }
      } // some filers could create only seo urls if 
      // the category is residential only
      // they are mapped inside the costant FEATURES_VALID_FOR_RESIDENTIAL_ONLY in ./utils/helpers/SeoManagerHelpers
      // this logic is not valid for Hubpages
      // questo discorso non vale per le hubpages che hanno bisogno 


      var isHubpage = !!(params.liste && params.comuni);

      if ((0, _helpers.checkIfFiltersAreValidJustForResidential)({
        features: Object.keys(params),
        group: params.propertyTypeGroup
      }) && !isHubpage) {
        return this.encodeSrpUrl(params, locations);
      }

      if (has_locations) {
        paramsPath.push(this.getLocationStr(locations));
        delete qs.locations;
      }
      /* TECH-7860 - TRASPASOS */


      if (params.license_type_groups) {
        var license_type_groups = (0, _SeoManagerHelpers.getLicenseTypeGroupSlugFromKey)(params.license_type_groups[0], this.lang);

        if (license_type_groups) {
          if (validPtype && (_SeoManagerHelpers.PTYPES_FOR_LICENSE_TYPE_GROUPS_SEOURL[validPtype] || []).includes(license_type_groups)) {
            paramsPath.push(license_type_groups);
            delete qs.license_type_groups;
          } else {
            return this.encodeSrpUrl(params, locations);
          }
        }
      }
      /* TECH-7860 - TRASPASOS */


      var features = [];
      var prefix_feature1 = 'con-';
      var prefix_feature2 = 'da-';

      if (params.garden && features.length < 1) {
        var getGardenFeature = function getGardenFeature() {
          var garden = "".concat(Array.isArray(params.garden) && params.garden.length > 1 ? 'giardino' : "giardino-".concat(params.garden));
          return garden;
        };

        features.push("".concat(prefix_feature1).concat(getGardenFeature()));
        delete qs.garden;
      }

      if (params.terrace && features.length < 1) {
        features.push("".concat(prefix_feature1, "terrazzo"));
        delete qs.terrace;
      }

      if (params.balcony && features.length < 1) {
        features.push("".concat(prefix_feature1, "balcone"));
        delete qs.balcony;
      }

      if (params.numParkingSpaces && features.length < 1) {
        features.push("".concat(prefix_feature1, "box-posto-auto"));

        if (params.numParkingSpaces === '1' || params.numParkingSpaces === 1) {
          delete qs.numParkingSpaces;
        }
      }

      if (params.has_swimming_pool && features.length < 1) {
        features.push("".concat(prefix_feature1, "piscina"));
        delete qs.has_swimming_pool;
      }

      if (params.availability && params.availability === 'nuda-proprieta' && features.length < 1) {
        features.push("".concat(prefix_feature1, "nuda-proprieta"));
        delete qs.availability;
      }

      if (params.only_auction && features.length < 1) {
        features.push("".concat(prefix_feature2, "asta-immobiliare"));
        delete qs.only_auction;
      }

      if (params.lift && features.length < 1) {
        if (params.lift === true || params.lift === 'true' || (0, _utils.isNumeric)(params.lift)) {
          features.push("".concat(prefix_feature1, "ascensore"));
        }

        if (params.lift === true || params.lift === 'true' || !(0, _utils.isNumeric)(params.lift) && params.lift !== false && params.lift !== 'false') {
          delete qs.lift;
        }
      }

      if (params.heatingType || params.heating) {
        var heatingType = params.heatingType || params.heating;

        if (!Array.isArray(heatingType)) {
          heatingType = heatingType.split(',');
        }

        if (features.length < 1) {
          features.push("".concat(prefix_feature1, "riscaldamento").concat(Array.isArray(heatingType) && heatingType.length > 1 ? '' : "-".concat(params.heatingType)));
          delete qs.heatingType;
          delete qs.heating;
        }
      }

      if (params.sellerType && features.length < 1) {
        var sellerType = !Array.isArray(params.sellerType) ? [params.sellerType] : params.sellerType;

        if (!sellerType.includes('agenzie')) {
          features.push("".concat(prefix_feature1, "da-").concat(sellerType.join('+')));
          delete qs.sellerType;
        } else {
          return this.encodeSrpUrl(params, locations);
        }
      }

      var otherParams = [];

      if (params.comuni) {
        otherParams.push(params.comuni);
        delete qs.comuni;
      }

      if (params.poi) {
        if (params.poi.subway && features.length === 0) {
          paramsPath.push("vicino-metro");
          delete qs.poi.subway;
        } else if (params.poi.electric_charging && features.length === 0 && (locations || []).filter(function (loc) {
          return loc.level > 11;
        }).length === 0) {
          paramsPath.push("vicino-colonnine-ricarica-auto");
          delete qs.poi.electric_charging;
        } else {
          return this.encodeSrpUrl(params, locations);
        }

        if (Object.keys(qs.poi).length === 0) {
          delete qs.poi;
        }
      }

      if (features.length) {
        paramsPath.push(features.join(''));
      }

      paramsPath.push(otherParams.join(''));

      if (params.tr) {
        delete qs.propertyTypeGroup;
      }

      if ('includeSurrounding' in params && (params.includeSurrounding === false || params.includeSurrounding === 'false')) {
        delete qs.includeSurrounding;
      }

      if ('surrounding' in params && (params.surrounding === false || params.surrounding === 'false')) {
        delete qs.surrounding;
      }

      if ('sortType' in params && params.sortType === 'relevance') {
        delete qs.sortType;
      }

      if ('sort' in params && params.sort === 'relevance') {
        delete qs.sort;
      }

      if ('misc' in params && (params.misc === 'undefined' || params.misc === undefined)) {
        delete qs.misc;
      }

      if ('page' in params && (params.page === 1 || params.page === '1')) {
        delete qs.page;
      }

      if ('isRoomsNumber' in params) {
        delete qs.isRoomsNumber;
      }

      var hasSomeFilterInCommon = (0, _helpers.checkWhitelistFiltersInCommonWith)({
        qs: qs
      });
      var gqs = this.getQS(qs);
      /*
        TECH-6201 Force /srp?.. url if there is some queryString like filter
      */

      if (hasSomeFilterInCommon && gqs && gqs.length > 0) {
        return this.encodeSrpUrl(params, locations);
      }

      var url = "/".concat(paramsPath.filter(Boolean).join('/')).concat(gqs.length ? gqs : '/').replace(/\/\//g, '/');
      return url;
    }
  }, {
    key: "encodeAgencySrpUrl",
    value: function encodeAgencySrpUrl(params) {
      var agencyName = params.agencyName,
          _params$locations = params.locations,
          locations = _params$locations === void 0 ? [] : _params$locations,
          q = params.q;

      var qs = _objectSpread({}, params, {}, q && {
        q: q
      }, {}, agencyName && {
        agencyName: decodeURIComponent(agencyName)
      });

      delete qs.locations;
      var locString = '';
      var hasFinalSlash = true;
      var uri = '';
      var has_valid_locations = this.isValidLocationForSeoUrl(locations);
      var lengthLoc = locations && locations.length || 0;
      var nameForceSrp = lengthLoc !== 1 && agencyName; // NOT SEO AGENCY URL

      if (lengthLoc > 1 || q || nameForceSrp) {
        uri = this.encodeSrpUrl(params, locations);
        hasFinalSlash = false;
      } else {
        var gqs = this.getQS(qs);

        if (has_valid_locations && Array.isArray(locations) && locations.length > 0) {
          locString = "/".concat(this.getLocationStr(locations));
          uri = "".concat(locString);
        }

        if (gqs && gqs.length) {
          uri = "".concat(uri).concat(gqs);
          hasFinalSlash = false;
        }
      }

      var addFinalSlash = hasFinalSlash ? '/' : '';
      return "/agenzie".concat(uri).concat(addFinalSlash);
    }
  }, {
    key: "encodePdpUrl",
    value: function encodePdpUrl(params) {
      if ('listingId' in params) {
        return "/immobili/".concat(params.listingId, "/");
      } else return '';
    }
  }, {
    key: "encodeHrefLang",
    value: function encodeHrefLang(params) {
      var _this3 = this;

      var locations = params.locations;
      var href_lang = {};
      var ret = {};
      var _params$isAgencySrp = params.isAgencySrp,
          isAgencySrp = _params$isAgencySrp === void 0 ? false : _params$isAgencySrp,
          _params$total_listing = params.total_listings,
          total_listings = _params$total_listing === void 0 ? 0 : _params$total_listing,
          publisher = params.publisher,
          _params$smallTownCano = params.smallTownCanonicalParams,
          smallTownCanonicalParams = _params$smallTownCano === void 0 ? false : _params$smallTownCano;
      delete params.isAgencySrp;
      delete params.total_listings;
      delete params.smallTownCanonicalParams;

      if (this.isValidParamsForSeoUrl(params, locations) || isAgencySrp) {
        this.supported_lang_slug.map(function (l) {
          _this3.lang = l;
          var canonicalLocations = (0, _MetroStopsDisambiguation["default"])(locations);
          var canonicalParams = smallTownCanonicalParams || params;

          var uri = _this3.finalUrlToLangUrl(isAgencySrp ? _this3.encodeAgencySrpUrl(params, locations) : _this3.encodeSeoUrl(canonicalParams, canonicalLocations));

          var t = (0, _SeoManagerHelpers.getTypeOfPageFromUri)(uri);
          var pagetype = !t.lista && t.page && t.page > 1 ? "?page=".concat(t.page) : '';
          /**
           * Le ricerche ordinate per prezzo o superficie con >200 risultati hanno ora valenza SEO
           * pertanto la loro url deve essere un canonical
           */

          var splitOnQs = uri.split(/[?#]/);

          if (splitOnQs.length === 2 && ['price_desc', 'price_asc', 'surface_desc', 'surface_asc'].includes(splitOnQs[1].replace('sortType=', '')) && total_listings > 200) {
            href_lang[l] = "".concat(splitOnQs[0]).concat(pagetype ? "".concat(pagetype, "&") : '?').concat(splitOnQs[1]);
          } else {
            href_lang[l] = "".concat(splitOnQs[0]).concat(pagetype);
          }

          if (href_lang[l].slice(-1) !== '/' && href_lang[l].indexOf('?') === -1) {
            href_lang[l] += '/';
          }
        });
        ret.canonical = href_lang[this.lang];
        ret.seo = ret.canonical;
        ret.hreflang = href_lang;
      }
      /**
       * feature/TECH-7154 give canonical to publisher srp search with pId
       */


      if (publisher) {
        ret.canonical = this.encodeSeoUrl(publisher, []);
        ret.seo = ret.canonical;
        href_lang[this.lang] = ret.canonical;
        ret.hreflang = href_lang;
      }

      ret.srp = this.encodeSrpUrl(params, locations);
      ret.srpMap = this.encodeSrpUrl(Object.assign({}, params, {
        isMap: true
      }), locations);
      return ret;
    }
  }, {
    key: "encode",
    value: function encode(params) {
      var locations = params.locations || params.localities || [];
      var _params$isAgencySrp2 = params.isAgencySrp,
          isAgencySrp = _params$isAgencySrp2 === void 0 ? false : _params$isAgencySrp2,
          _params$forceSrp = params.forceSrp,
          forceSrp = _params$forceSrp === void 0 ? false : _params$forceSrp;
      delete params.forceSrp;
      delete params.isAgencySrp;
      var final_url;

      if (isAgencySrp) {
        final_url = this.encodeAgencySrpUrl(params, locations);
      } else if (forceSrp) {
        final_url = this.encodeSrpUrl(params, locations);
      } else if ('listingId' in params) {
        final_url = this.encodePdpUrl(params);
      } else if (this.isValidParamsForSeoUrl(params, locations)) {
        final_url = this.encodeSeoUrl(params, locations);
      } else {
        final_url = this.encodeSrpUrl(params, locations);
      }

      return this.finalUrlToLangUrl(final_url);
    }
  }]);

  return SeoManagerEncoderV2;
}(_BaseSeoManagerEncoder["default"]);

var _default = SeoManagerEncoderV2;
exports["default"] = _default;